import { Component } from '@angular/core';

@Component({
  selector: 'cx-register-layout',
  templateUrl: './register-layout.component.html',
  styleUrls: ['./register-layout.component.scss']
})
export class RegisterLayoutComponent {
  constructor() {}
}
